import { Button } from '@mantine/core';
import { IconFileTypeZip } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface EvaluationFacultyArchiveButtonProps {
  evaluationId: Id;
}

const onDownload = (evaluationId: Id) => {
  window.open(`/api/gov-evaluation/${evaluationId}/download-faculty-archive-zip`);
};

export function GovEvaluationFacultyArchiveButton({ evaluationId }: EvaluationFacultyArchiveButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeZip size="24px" />}
      onClick={() => onDownload(evaluationId)}
    >
      Descarcă arhiva grupată pe facultate
    </Button>
  );
}
